import { render, staticRenderFns } from "./CustomerMatchSummaryStandard.vue?vue&type=template&id=bfcbd044"
import script from "./CustomerMatchSummaryStandard.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchSummaryStandard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchSummaryStandard.vue?vue&type=style&index=0&id=bfcbd044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports